
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news-serp",
      function () {
        return require("private-next-pages/news-serp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news-serp"])
      });
    }
  